module.exports = __webpack_public_path__ + "ea4bb332d8bb329ab2a15986808cdc5c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/kitten.png
// module id = 3069
// module chunks = 2